//#region src/components/RRule/utils/format-length.ts
/** "45m" | "1h" | "8h 30m" | "24h" | "0m" — minutes shown only when non-zero. */
function formatLength(durationMin) {
	const hours = Math.floor(durationMin / 60);
	const mins = durationMin % 60;
	if (hours === 0) return `${mins}m`;
	if (mins === 0) return `${hours}h`;
	return `${hours}h ${mins}m`;
}
//#endregion
export { formatLength };

//# sourceMappingURL=format-length.js.map